var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 109.3L415.8 90.28C423.3 85.73 433.2 88.19 437.7 95.77C442.3 103.3 439.8 113.2 432.2 117.7L392.2 141.7C387.2 144.8 380.8 144.8 375.8 141.7L335.8 117.7C328.2 113.2 325.7 103.3 330.3 95.77C334.8 88.19 344.7 85.73 352.2 90.28L384 109.3zM384 256C392.8 256 400 263.2 400 272C400 280.8 392.8 288 384 288H128C119.2 288 112 280.8 112 272C112 263.2 119.2 256 128 256H384zM384 352C392.8 352 400 359.2 400 368C400 376.8 392.8 384 384 384H128C119.2 384 112 376.8 112 368C112 359.2 119.2 352 128 352H384zM0 96C0 60.65 28.65 32 64 32H448C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96zM32 96V160H480V96C480 78.33 465.7 64 448 64H64C46.33 64 32 78.33 32 96zM32 416C32 433.7 46.33 448 64 448H448C465.7 448 480 433.7 480 416V192H32V416z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDropdown);
export default __webpack_public_path__ + "static/media/list-dropdown.29bb55ffa00ee6adda46f45074f5beeb.svg";
export { ForwardRef as ReactComponent };